import { CellSelection } from 'common/Prose/utils/table/CellSelection'
import { addDeletionMarks } from '../addDeletionMarks'
import { getContext } from '../utils'
import { TrackedChangesCommandHandler } from './types'

export const deleteCellContents: TrackedChangesCommandHandler = ({ originalTr, wrappedTr, map, state, userId }) => {
  const context = getContext(originalTr)
  const selection = wrappedTr.selection
  if (!(selection instanceof CellSelection)) {
    return false
  }

  selection.$includedCells.forEach(($cellPos) => {
    const from = $cellPos.pos + 1 // +1 to right before content, pos is right before cell
    const to = $cellPos.pos + ($cellPos.nodeAfter?.content.size ?? 0)

    if ($cellPos.nodeAfter) {
      addDeletionMarks(wrappedTr, from, to, userId, context)
    }
  })
  return true
}
